import React, {useEffect, useState} from "react";
import {useVsiAppContext} from "../../../stores/VsiApp";
import {useAuthWithRoute, useDataWithRoute, useTitleFromComponent} from "../../../utils/hooks";
import {VsiBubble, VsiH4, VsiH5} from "../../../styled/App.styled";
import Grid from "../../../components/Grid";
import {Card, Col, Row, Spinner} from "reactstrap";
import {adminColumnDefs, adminAlertsDefs} from "../../../utils/gridColumnDefs/security/administrativeReportDefs";

export default function AdministrativeReport({title, context}) {
    useTitleFromComponent(`${context} / ${title}`);
    const { theme, client } = useVsiAppContext();
    const [loginData, setLoginData] = useState([]);
    const [devicesData, setDevicesData] = useState([]);
    const [userData, setUserData] = useState([]);
    const [alertsData, setAlertsData] = useState([]);

    const [data, {isLoading}] = useAuthWithRoute(`/api/v6/admin/security_logs/${client.clientId}`);
    const [alertsLogs, {isAlertsLoading}] = useDataWithRoute(`/api/v6/report/enterprise_acknowledge_alerts_log_proc?client_id=${client.clientId}`);

    useEffect(() => {
        let loginLogs = [];
        let deviceLogs = [];
        let userLogs = [];

        data.map(datum => {
            if(datum.message.includes("Success")) {
                datum['status'] = 1
            } else if (datum.message.includes("Failed")) {
                datum['status'] = 0
            }

            if (datum.message.includes("Login") || datum.message.includes("Token verification") || datum.message.includes("Logout")) {
                loginLogs.push(datum)
            } else if (datum.message.includes("Collection Device")) {
                deviceLogs.push(datum)
            } else if (datum.message.includes("Device")) {
                deviceLogs.push(datum)
            } else if (datum.message.includes("User") || datum.message.includes("API Key")) {
                userLogs.push(datum)
            }
        });

        setLoginData(loginLogs);
        setDevicesData(deviceLogs);
        setUserData(userLogs);
        setAlertsData(alertsLogs.recordset || [])

    }, [data, alertsLogs]);
    
    return (
        <Card className={`report-card p-2 nav-card-${theme}`}>
            <VsiH4>Administrative Report</VsiH4>
            {(isLoading || isAlertsLoading) ? <Spinner color={"primary"}/> : (
                <>
                    <Row>
                        <Col>
                            <VsiH5 className={"mt-2"}>Login Report</VsiH5>
                            <VsiBubble noAutobot>
                                <Grid
                                    addStyle
                                    maxHeight={500}
                                    data={loginData}
                                    columnDefs={adminColumnDefs}
                                    saveParams={{metric: "login"}}
                                />
                            </VsiBubble>
                        </Col>
                        <Col>
                            <VsiH5 className={"mt-2"}>Acknowledge Alerts</VsiH5>
                            <VsiBubble noAutobot>
                                <Grid
                                    addStyle
                                    maxHeight={500}
                                    data={alertsData}
                                    columnDefs={adminAlertsDefs}
                                    saveParams={{metric: "alerts"}}
                                />
                            </VsiBubble>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <VsiH5 className={"mt-2"}>Device Changes</VsiH5>
                            <VsiBubble noAutobot>
                                <Grid
                                    addStyle
                                    data={devicesData}
                                    columnDefs={adminColumnDefs}
                                    saveParams={{metric: "device"}}
                                />
                            </VsiBubble>
                        </Col>
                        <Col>
                            <VsiH5 className={"mt-2"}>User Changes</VsiH5>
                            <VsiBubble noAutobot>
                                <Grid
                                    addStyle
                                    data={userData}
                                    columnDefs={adminColumnDefs}
                                    saveParams={{metric: "user"}}
                                />
                            </VsiBubble>
                        </Col>
                    </Row>
                </>
            )}
        </Card>
    )
}
